/**
 * author: Ananthapadmanabhan V K
 */
import {
  ArcElement,
  BarElement,
  CategoryScale,
  Chart as ChartJS, Legend,
  LineElement,
  LinearScale,
  PointElement,
  Title,
  Tooltip
} from "chart.js";
import React, { useContext, useEffect, useState } from "react";
import { ProgressBar } from "react-bootstrap";
import { withTranslation } from "react-i18next";
import { RegulationContext } from "../../../App";
import CompanyDashboardService from "../../../core/service/CompanyDashboardService";
import Utils from "../../../core/utilities/Utils";
import SupplierRiskCountCard from "../../Common/Supplier/SupplierRiskCountCard";
import CompanyRiskCard from "../CompanyRiskCard/CompanyRiskCard";
import "./CompanyDashboard.scss";

import 'react-circular-progressbar/dist/styles.css';
import DashboardForStandard from "./DashboardForStandard";
import ChartDataLabels from "chartjs-plugin-datalabels";
import { CgSortAz } from 'react-icons/cg';

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  ArcElement,
  LineElement,
  PointElement,
  Title,
  Tooltip,
  Legend,
  ChartDataLabels
);

const CompanyDashboard = ({ t }) => {

  var lsDat = JSON.parse(localStorage.getItem("authority"));
  var companyId = lsDat.profile.company.id;
  const { glbRegulation, setGlbRegulation } = useContext(RegulationContext);
  const [riskparamdata, setRiskParamData] = useState([]);
  const [highrisksupplier, setHighRiskSupplier] = useState([]);
  const [highriskcountries, setHighRiskCountries] = useState([]);
  const [companyrisk, setCompanyRisk] = useState(null);
  const [labelscountry, setLabelsCountry] = useState([]);
  const [countrygraphdata, setCountryGraphData] = useState(null);
  const glbRegulationId = glbRegulation?.id ? glbRegulation.id : "";
  const [frequency, setFrequency] = useState("");
  const [annualyear, setAnnualYear] = useState(new Date().getFullYear());
  const [frequencymonth, setFrequencyMonth] = useState('');
  const [configType, setConfigType] = useState('Supplier');
  const [countrytopfive, setCountryTopFive] = useState([]);
  const [showFilter, setShowFilter] = useState(false);

  useEffect(() => {
    if (!glbRegulationId || glbRegulation?.type === 'S') return;

    setFrequency(glbRegulation.frequency);
    const month = Utils.getMonthFromFrequency(glbRegulation.frequency);
    setFrequencyMonth(month);
    getDashboardData(annualyear, month);
    getHighRiskSuppliers(annualyear, month);
    getTopCountryRisk(annualyear, month);
    getSupplierStatusCountryReport();
  }, [glbRegulationId, annualyear]);


  const getDashboardData = (year, month, type = '') => {
    let frequencyParam = year + '-' + month + '-01';
    let cType = type ? type : configType;
    if (cType === "Supplier") {
      CompanyDashboardService.getDashboardData(
        companyId,
        glbRegulationId,
        frequencyParam
      )
        .then((response) => {
          setRiskParamData(response.data.riskParams);
          setCompanyRisk(response.data.companyRisk);
        })
        .catch((error) => {
        });
    } else {
      CompanyDashboardService.getCompanyRiskData(
        companyId,
        glbRegulationId,
        frequencyParam
      )
        .then((response) => {
          setRiskParamData(response.data.riskParams);
          setCompanyRisk(response.data.companyRisk);
        })
        .catch((error) => {
        });
    }

  };

  const getHighRiskSuppliers = (year, month) => {
    let frequencyParam = year + '-' + month + '-01';
    var string = Utils.generateUrlParamCompanyRegulation(
      companyId,
      glbRegulationId
    );
    var encodedDat = Utils.encodeBase64(string);
    CompanyDashboardService.getHighRiskSuppliers(encodedDat, frequencyParam)
      .then((response) => {
        setHighRiskSupplier(response.data);
      })
      .catch((error) => {
      });
  };

  const getTopCountryRisk = (year, month) => {
    let frequencyParam = year + '-' + month + '-01';
    CompanyDashboardService.getTopCountryRisk(
      companyId,
      glbRegulationId,
      frequencyParam
    ).then((response) => {
      let arrCountry = [];
      let arrCount = [];
      for (let i = 0; i < response.data.length; i++) {
        arrCountry.push(response.data[i].country);
        arrCount.push(response.data[i].total);
      }
      setLabelsCountry(arrCountry);
      const data = {
        labels: arrCountry,
        datasets: [
          {
            label: t("NoOfSuppliers.label"),
            data: arrCount,
            backgroundColor: "rgba(255, 99, 132, 0.5)",
          },
        ],
      };
      setCountryGraphData(data);
      setHighRiskCountries(response.data);
    }).catch((error) => {
    });
  };

  const highRiskProgressBarGenerate = (item) => {
    if (item) {
      if (item.resultType != null) {
        let colorClass = "color-" + item.resultType.colorCode.replace(/^#/, "");
        return (
          // 
          <><ProgressBar
            now={item.weightedScore * 10}
            // label={parseFloat(item.weightedScore.toFixed(1))}
            className={colorClass}
          /> {item.weightedScore != 0 && <span>{item.weightedScore.toFixed(1)}</span>}</>
        );
      } else {
        return (
          <><ProgressBar
            now={item.weightedScore * 10}
          // label={parseFloat(item.weightedScore.toFixed(1))}
          />{item.weightedScore != 0 && <span>{item.weightedScore.toFixed(1)}</span>}</>
        );
      }
    }
  };

  const callbackRisk = (data) => {
    setConfigType(data.configType);
    getDashboardData(annualyear, frequencymonth, data.configType);
  };

  const getSupplierStatusCountryReport = () => {
    var month = Utils.getMonthFromFrequency(glbRegulation.frequency);
    CompanyDashboardService.getSupplierStatusCountryReport(
      companyId,
      glbRegulationId,
      annualyear + '-' + month + '-01',
    ).then((response) => {
      setCountryTopFive([...response.data])
    }).catch((error) => {
    });
  };

  return (
    <>
      {/* <div className="List_header">
        <h5 className="MH">{t("Dashboard.label")}</h5>
      </div> */}
      <div className="CompanyDashboard">
        {glbRegulation?.type === 'R'
          ? <div className="CompanyDashboard_inner">
            <div className="row m-0">
              <div className="col-lg-4 p-0">
                <CompanyRiskCard companyrisk={companyrisk} riskparamdata={riskparamdata} callbackRisk={callbackRisk} />
              </div>
              <div className="col-lg-8 p-0">
                <div>
                  <SupplierRiskCountCard selYear={annualyear} />
                </div>
                <div className="row m-0">
                  <div className="col-lg-6 Top5_cardin">
                    <div className="card mb-3 CD-Risk_02 border-0">
                      <div className="card-body p-0">
                        <div className="p-3">
                          <strong>{t("Top5HighRiskSuppliers.label")}</strong>
                        </div>
                        <div className="CD-Top5HighRiskSuppliersView02">
                          <div className="CD-Top5RiskView02_in">
                            <ul>
                              <li>
                                <p className="m-0"> {t("Suppliers.label")}</p>
                              </li>
                              <li>
                                <p className="m-0">{t("Score.label")} (1-10)</p>
                              </li>
                            </ul>
                          </div>
                          {highrisksupplier &&
                            highrisksupplier?.map((item, idx) => (
                              <div className="CD-Top5RiskView02_in" key={idx}>
                                <ul>
                                  <li>{item.supplier.legalName}</li>
                                  <li>{highRiskProgressBarGenerate(item)}</li>
                                </ul>
                              </div>
                            ))}
                          <div className="CD-Top5RiskView02_footer">
                            <a href="#">View More</a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-6 Top5_cardin">
                    <div className="card mb-2 CD-Risk_02 border-0">
                      <div className="card-body p-0">
                        <div className="p-3">
                          <strong>{t("Top5HighRiskCountries.label")}</strong>
                        </div>
                        <div className="Top5HighRiskCountries_view">
                          <div className="CD-Top5HighRiskView02_in">
                            <ul>
                              <li>
                                <p className="m-0"> {t("Countries.label")}</p>
                              </li>
                              <li>
                                <p className="m-0">No.of Suppliers</p>
                              </li>
                            </ul>
                          </div>
                          {countrytopfive.map((item, idx) => (
                            <div className="CD-Top5HighRiskView02_in">
                              <ul>
                                <li>{item.country}</li>
                                <li>
                                  <ProgressBar
                                    now={item.total}
                                  //  label="new"
                                  />{item.total > 0 && <span>{item.total}</span>}
                                </li>
                              </ul>
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          :
          <DashboardForStandard />
        }
      </div>
    </>
  );
};
export default withTranslation()(CompanyDashboard);
